import { useState } from "react";

import { installUrl } from "@/api/ikas";
import { Button } from "@/components/ui";
import { t } from "@/i18n";

interface IkasConnectProps {
  /** `ikas.store_name` ayari — dolu ise OAuth zaten tamamlanmis demektir
   * (backend callback'i bunu yazar, ikas.py:285-294). Sayfa her yuklendiginde
   * bu deger okunarak "bagli mi" durumu KURTARILIR — App.tsx'teki
   * `/kurulum/ikas/tamam` rotasi (initialStep="credentials") dogrudan bu
   * adimi actiginda da, kullanici elle /kurulum → Ileri ile buraya geldiginde
   * de dogru durum GORUNUR. */
  storeName: string;
  onRegisterWebhooks: () => void;
  isRegistering: boolean;
  registerError: string | null;
  registerSuccess: boolean;
}

export function IkasConnect({ storeName, onRegisterWebhooks, isRegistering, registerError, registerSuccess }: IkasConnectProps) {
  const [storeInput, setStoreInput] = useState("");
  const connected = storeName.trim().length > 0;

  if (connected) {
    return (
      <div className="space-y-3">
        <p className="text-sm font-medium text-green">{t("kurulum.ikas.connected", { store: storeName })}</p>
        {registerError && (
          <p role="alert" className="text-sm text-red">
            {registerError}
          </p>
        )}
        {registerSuccess && (
          <p role="status" className="text-sm text-green">
            {t("kurulum.ikas.webhooks_registered")}
          </p>
        )}
        <Button type="button" variant="primary" disabled={isRegistering} onClick={onRegisterWebhooks}>
          {isRegistering ? t("kurulum.ikas.webhooks_registering") : t("kurulum.ikas.register_webhooks")}
        </Button>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <label className="block">
        <span className="label">{t("kurulum.ikas.store_name")}</span>
        <input
          value={storeInput}
          onChange={(e) => setStoreInput(e.target.value)}
          placeholder={t("kurulum.ikas.store_hint")}
          className="input"
        />
      </label>
      <Button
        type="button"
        variant="primary"
        disabled={!storeInput.trim()}
        onClick={() => {
          window.location.assign(installUrl(storeInput.trim()));
        }}
      >
        {t("kurulum.ikas.install")}
      </Button>
    </div>
  );
}
